import { useCallback, useEffect, useRef, useState } from "react";
import BaseScreen from "../BaseScreen";
import {
  color_333333,
  color_999999,
  color_BEBEBE,
  color_main,
  transparent,
  white,
  ColorLine,
  ColorGrey,
} from "../../assets/style/colors";
import NavBar from "../../components/NavBar";
import {
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  FlatList,
} from "react-native";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import * as ImSdk from "../../../imsdk/api";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Popover from "react-native-popover-view";
import { MainNavProps } from "../navigation/main/MainParamList";
import {
  Str_CreateAddLabel,
  Str_AddFail,
  Str_AddLabel,
  Str_AddSucc,
  Str_CreateFail,
  Str_CreateSucc,
  Str_Delete,
  Str_LabelAlreadyExists,
  Str_LabelNotNull,
  Str_ShiftOutFail,
  Str_ShiftOutSucc,
  Str_Add,
  Str_Edit,
  Str_AllLabel,
  Str_SelectOrSearchLabel,
} from "../../language/string_res";
import { ScrollView } from "react-native-gesture-handler";
import { useIsFocused } from "@react-navigation/native";
import { ButtonView } from "../../components/ButtonView";
import { ScreenCloseModal } from "../../components/ScreenModal";
import { AddLabelModal } from "../label/ContactsLabelScreenModal";

const backgroundColor = "#ebe9ec";

export const ContactsLabel = ({
  navigation,
  route,
}: MainNavProps<"ContactsLabel">) => {
  const user = route.params.user;
  const [labels, setLabels] = useState<string[]>();
  const labelsRef = useRef<string[]>();
  const [allLabels, setAllLabels] = useState<string[]>();
  const allLabelsRef = useRef<string[]>();
  const [flatLabels, setFlatLabels] = useState<string[]>();
  const [addLabelVis, setAddLabelVis] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const insets = useSafeAreaInsets();
  const im = ImSdk.getInstance();
  const isFoucsed = useIsFocused();

  useEffect(() => {
    if (!isFoucsed) {
      return;
    }
    im.GetAllLabels().then((r) => {
      if (r.labels && r.labels.length > 0) {
        const lbs = r.labels.map((v) => v.label);
        setAllLabels(lbs);
      }
    });
    im.GetLabelsByUid(user.uid).then((r) => {
      if (r.labels && r.labels.length > 0) {
        const lbs = r.labels.map((v) => v.label);
        setLabels(lbs);
      }
    });
  }, [isFoucsed]);

  useEffect(() => {
    labelsRef.current = labels;
  }, [labels]);

  useEffect(() => {
    allLabelsRef.current = allLabels;
  }, [allLabels]);

  useEffect(() => {
    if (searchVal.length > 0) {
      const lbs = allLabels?.filter(
        (v) => v.includes(searchVal) && !labels?.includes(v)
      );
      setFlatLabels(lbs);
    }
  }, [searchVal, labels, allLabels]);

  const onAddLabelClose = useCallback(() => {
    setAddLabelVis(false);
  }, []);

  const addLabel = (text: string, isCreate: boolean = true) => {
    if (text.length === 0) {
      showToast(Str_LabelNotNull);
      return;
    }
    if (labels && labels.includes(text)) {
      showToast(Str_LabelAlreadyExists);
      return;
    }
    showLoading();
    const type = allLabels?.includes(text) ? 0 : 1;
    im.AddLabel(text, [user], type).then((r) => {
      hideLoading();
      setTimeout(() => {
        if (!r.error) {
          showToast(isCreate ? Str_CreateSucc : Str_AddSucc);
          AddLabels(text, type);
        } else {
          showToast(r.error || isCreate ? Str_CreateFail : Str_AddFail);
        }
      }, 300);
    });
  };

  const delLabel = useCallback((label: string) => {
    setTimeout(() => {
      showLoading();
      ImSdk.getInstance()
        .DelLabelUids(label, [user.uid])
        .then((r) => {
          hideLoading();
          if (!r.error) {
            showToast(Str_ShiftOutSucc);
            RemoveLabels(label);
          } else {
            showToast(r.error || Str_ShiftOutFail);
          }
        });
    }, 500);
  }, []);

  const AddLabels = useCallback((label: string, type: 0 | 1) => {
    if (labelsRef.current) {
      setLabels([label, ...labelsRef.current]);
    } else {
      setLabels([label]);
    }
    if (type === 1) {
      if (allLabelsRef.current) {
        setAllLabels([label, ...allLabelsRef.current]);
      } else {
        setAllLabels([label]);
      }
    }
  }, []);
  const RemoveLabels = useCallback((label: string) => {
    const newLabels = labelsRef.current?.filter((v) => v !== label);
    setLabels(newLabels);
  }, []);

  const AddModalItem = ({
    text,
    isAdd,
    isSelect,
    isAll,
  }: {
    isAdd: boolean;
    text: string;
    isSelect: boolean;
    isAll: boolean;
  }) => {
    const [showPopover, setShowPopover] = useState(false);

    const handleItemClick = () => {
      if (isAdd) {
        setAddLabelVis(true);
      } else {
        if (Platform.OS === "web") {
          // Web 环境下直接执行操作，不使用 Popover
          if (isSelect) {
            delLabel(text);
          } else {
            addLabel(text, false);
          }
        } else {
          setShowPopover(true);
        }
      }
    };

    const button = (
      <Pressable
        key={text}
        onPress={handleItemClick}
        style={({ pressed }) => [
          styles.itemStyle,
          {
            backgroundColor: isAdd ? ColorGrey : color_main,
          },
          Platform.OS === "web" &&
          pressed && {
            opacity: 0.8,
            transform: [{ scale: 0.98 }],
          },
        ]}
      >
        <Text
          numberOfLines={1}
          style={{
            color: isAdd ? color_333333 : "white",
            fontSize: 14,
            fontWeight: isAdd ? "400" : "500",
          }}
        >
          {text}
        </Text>
      </Pressable>
    );

    if (Platform.OS === "web") {
      // Web 环境下不使用 Popover
      return button;
    }

    // 移动端使用 Popover
    return (
      <Popover
        key={text}
        onRequestClose={() => setShowPopover(false)}
        onCloseComplete={() => setShowPopover(false)}
        isVisible={showPopover}
        backgroundStyle={{ backgroundColor: transparent }}
        popoverStyle={styles.popoverStyle}
        from={button}
      >
        <ButtonView
          onPress={() => {
            setShowPopover(false);
            if (isSelect) {
              delLabel(text);
            } else {
              addLabel(text, false);
            }
          }}
          textStyle={{ color: "white", fontSize: 17 }}
          text={isSelect ? Str_Delete : Str_Add}
        />
      </Popover>
    );
  };

  const renderItem = ({ item }: { item: string }) => {
    return (
      <Pressable
        onPress={() => {
          addLabel(item, false);
          setSearchVal("");
        }}
        style={({ pressed }) => [
          styles.webSearchResultItem,
          Platform.OS === "web" && {
            cursor: "pointer",
            opacity: pressed ? 0.7 : 1,
          },
        ]}
      >
        <Text style={styles.webSearchResultText}>{item}</Text>
      </Pressable>
    );
  };
  const onSubmitEditing = () => {
    const include = labels?.includes(searchVal) ?? false;
    let isCreate = true;
    if (allLabels) {
      isCreate = !allLabels.includes(searchVal);
    }
    setSearchVal("");
    if (!include) {
      addLabel(searchVal, isCreate);
    }
  };

  return (
    <ScreenCloseModal title={Str_AddLabel}>
      <View style={styles.webContainer}>
        {/* 已选标签部分 */}
        <View style={styles.webSelectedTagsContainer}>
          <Text style={styles.webSectionTitle}>已选标签</Text>
          <View style={styles.webSelectedTagsWrapper}>
            {labels && labels.length > 0 && (
              <View style={styles.webSelectedTagsList}>
                {labels.map((v) => {
                  return (
                    <AddModalItem
                      key={v}
                      isAdd={false}
                      text={v}
                      isSelect={true}
                      isAll={false}
                    />
                  );
                })}
              </View>
            )}
            <View
              style={[
                styles.webSearchContainer,
                {
                  borderWidth: 1,
                  borderColor: searchVal.length > 0 ? color_main : ColorLine,
                },
              ]}
            >
              <TextInput
                maxLength={28}
                style={styles.webSearchInput}
                onChangeText={setSearchVal}
                placeholder={Str_SelectOrSearchLabel}
                editable={true}
                selectionColor={color_main}
                placeholderTextColor={color_BEBEBE}
                value={searchVal}
                returnKeyType={"done"}
                onSubmitEditing={onSubmitEditing}
                focusable={true}
              />
            </View>
          </View>
        </View>

        <View style={styles.webDivider} />

        {/* 全部标签部分 */}
        <View style={styles.webAllTagsContainer}>
          <Text style={styles.webSectionTitle}>{Str_AllLabel}</Text>
          {searchVal.length > 0 ? (
            <View style={styles.webSearchResultsContainer}>
              <FlatList
                keyExtractor={(index) => index.toString()}
                renderItem={renderItem}
                data={flatLabels}
                style={styles.webFlatList}
              />
            </View>
          ) : (
            <View style={styles.webAllTagsList}>
              {allLabels?.map((v) => {
                const isSelect = labels?.includes(v) ?? false;
                return isSelect ? null : (
                  <AddModalItem
                    key={v}
                    isAdd={false}
                    text={v}
                    isSelect={isSelect}
                    isAll={true}
                  />
                );
              })}
              <AddModalItem
                isAdd={true}
                text={Str_CreateAddLabel}
                isSelect={false}
                isAll={false}
              />
            </View>
          )}
        </View>
      </View>

      <AddLabelModal
        visible={addLabelVis}
        onClose={onAddLabelClose}
        addLabel={addLabel}
      />
    </ScreenCloseModal>
  );
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 12,
    flexDirection: "row",
    flexWrap: "wrap",
  },
  searchContainer: {
    borderRadius: 20,
    borderColor: "#ccc",
    height: 26,
    alignItems: "center",
    flexDirection: "row",
    marginEnd: 10,
    marginTop: 10,
    paddingHorizontal: 10,
  },
  popoverStyle: {
    backgroundColor: color_333333,
    borderRadius: 10,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  itemStyle: {
    paddingHorizontal: 14,
    height: 32,
    minWidth: 60,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    ...(Platform.OS === "web" && {
      cursor: "pointer",
      transition: "opacity 0.2s, transform 0.2s",
    }),
  },
  // Web 样式
  webContainer: {
    flex: 1,
    width: "100%",
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 24,
    backgroundColor: white,
    ...(Platform.OS === "web" && {
      width: 500,
      alignSelf: "center",
    }),
  },
  webSelectedTagsContainer: {
    marginBottom: 20,
  },
  webSelectedTagsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
  },
  webSelectedTagsList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  webSectionTitle: {
    fontSize: 15,
    fontWeight: "500",
    color: color_333333,
    marginBottom: 12,
  },
  webSearchContainer: {
    borderRadius: 6,
    height: 36,
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 12,
    flex: 1,
    backgroundColor: "white",
    ...(Platform.OS === "web" && {
      transition: "border-color 0.2s",
    }),
  },
  webSearchInput: {
    padding: 0,
    flex: 1,
    color: color_333333,
    fontSize: 14,
  },
  webDivider: {
    height: 1,
    backgroundColor: ColorLine,
    marginVertical: 20,
  },
  webAllTagsContainer: {
    ...(Platform.OS === "web" ? {} : { flex: 1 }),
  },
  webAllTagsHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  webEditButton: {
    cursor: "pointer",
  },
  webEditText: {
    color: color_333333,
    fontSize: 14,
  },
  webAllTagsList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  webSearchResultsContainer: {
    maxHeight: 400,
  },
  webFlatList: {
    maxHeight: 400,
  },
  webSearchResultItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: ColorLine,
    ...(Platform.OS === "web" && {
      transition: "background-color 0.2s",
    }),
  },
  webSearchResultText: {
    fontSize: 16,
    color: color_333333,
  },
});
